import { Color } from 'three';
import type { AppConfig, WeatherMode, QualityLevel } from './types.js';

export const CONFIG: AppConfig = {
  mode: 'auto',
  isPlaying: false,
  volume: 0.5,
  startTime: Date.now(),
  uiTimer: null,
  lastThunderTime: 0,
  thunderCooldown: 0,
  weatherSyncEnabled: false,
  quality: 'high',
  params: {
    rainIntensity: 0.0,
    snowIntensity: 0.0,
    cloudDensity: 0.5,
    cloudColor: new Color(),
    skyColor: new Color(),
    brightness: 1.0,
    lightningFlash: 0.0,
  },
  soundLevels: {
    rumble: 0.55,
    rain: 1.0,
    wind: 0.45,
    hiss: 0.35,
    birds: 0.0,
    fire: 0.0,
    stream: 0.0,
    windchime: 0.0,
  },
  timer: {
    enabled: false,
    duration: 25 * 60,
    remaining: 25 * 60,
    isRunning: false,
    intervalId: null,
    onEnd: null,
  },
};

export const PALETTES = [
  { hour: 0, sky: '#01050a', cloud: '#0a101a', rain: 0.4 },
  { hour: 6, sky: '#1a2530', cloud: '#607080', rain: 0.6 },
  { hour: 12, sky: '#203a55', cloud: '#8faabf', rain: 0.2 },
  { hour: 18, sky: '#101c2b', cloud: '#3d4c5e', rain: 0.5 },
  { hour: 21, sky: '#050912', cloud: '#151f2b', rain: 0.4 },
];

export function setMode(mode: WeatherMode): void {
  CONFIG.mode = mode;
  CONFIG.params.snowIntensity = 0;
  CONFIG.params.lightningFlash = 0;
  CONFIG.lastThunderTime = 0;
  CONFIG.thunderCooldown = 0;

  const dots = document.querySelectorAll('.mode-dot');
  dots.forEach((dot) => {
    dot.classList.remove('active');
    if ((dot as HTMLElement).dataset.mode === mode) {
      dot.classList.add('active');
    }
  });
}

export function setQuality(quality: QualityLevel): void {
  CONFIG.quality = quality;
}
